module.exports = __webpack_public_path__ + "static/media/marker_disruption_selected.e5f39f1b.svg";